const barbaAfterEnterFunctions = (data, ScrollTrigger, smoother) => {
  
  const $container = $(data.next.container);

  /*******************************************************************
    HACK FOR GSAP EFFECT DATA ATTRIBUTES TO RUN ON PAGE TRANSITIONS
  *******************************************************************/
  
  let $effects = $container.find('[data-gspeed]');

  if ($effects.length) {

    $effects.each(function() {

      const $this = $(this);
      const $speed = $this.data('gspeed');

      if ($this.data('glag')) {
        const $lag = $this.data('glag');
        smoother.effects($this, {speed: $speed, lag: $lag})
      } else {
        smoother.effects($this, {speed: $speed})
      }

    });

  }
  
  $('.no-click').add('.no-click a').on('click', (e) => {
    e.preventDefault();
  });
  
  //let $lazyItems = $container.find('img[loading="lazy"]');
    
  //$lazyItems.each(function() {
  //  $(this).on('load',function(){
  //    ScrollTrigger.refresh();
  //  });
  //});

  
}

export {
  barbaAfterEnterFunctions
};
